<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-3">
<h1>Chapter 3</h1>
<p>Looking back, I never thought of my parents as a couple, that is they were not a walking out arm in arm kind of couple. They always appeared two distinct, very different individuals. Their personalities seemed to have nothing in common, my father being light hearted and easy-going, my mother serious and hard working. There was definitely the feeling that she held things together as the one in charge. In their different ways they personified their national characteristics, she being thrifty and industrious, he being, well, not so. She dealt with problems, almost always financial, head on. He, with his ‘well, maybe it is all for the best’ philosophy managed to skirt around them. Although my father had a romantic nature, with his story telling from the past was such a big part of him, and one I always cherished, that seemed to have no marked effect on my mother.</p>
<p>They met since they lived next door to one another. That was a stroke of luck and a somewhat unlikely one given their circumstances. My father had returned to Ireland after serving in France but then left Ireland for Edinburgh. This was roughly in the mid-1920s. At the same time my mother was taking another direction leaving Edinburgh for America and after a failed marriage returning to Edinburgh. So theirs was a roundabout route to meeting and marrying with a few ups and downs on the way – not unlike marriage itself. They lived with their widely different attitudes to their Catholic faith, she a devout practising Catholic in a Protestant country, he the jesting non-believer from Catholic Ireland.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?10f34512